import { toast } from 'react-toastify';
import { CustomToastWithRetry } from 'shared/ui/custom-toast-with-retry';

export const showErrorToastWithRetry = (message, retryFn) => {
  const toastId = toast.error(
    <CustomToastWithRetry
      message={message}
      retryFn={() => {
        toast.dismiss(toastId);
        retryFn();
      }}
    />,
    {
      autoClose: 10000,
      closeOnClick: false,
    }
  );
};
